export default "__VITE_ASSET__C4KS0oT0__"